import React from 'react';
import { Form } from 'antd';
import { useUpdateDataExtraction } from '@/hooks';
import { useDataExtractionReport } from '@/context/DataExtractionReport';
import { StepFooterButtons } from '@/components/Settings/DataExtraction/components/StepFooterButtons';

const { useFormInstance } = Form;

export function Footer() {
	const form = useFormInstance();
	const { dataExtractionReport, onPreviousStep, onSetShowConfirmationModal } = useDataExtractionReport();

	const { isLoading, mutateAsync: updateDataExtraction } = useUpdateDataExtraction();

	async function handleOnSubmit(): Promise<void> {
		if (!dataExtractionReport?.id) return;

		try {
			const values = await form.validateFields();

			const selectedReports = values?.action_plans?.selected_reports || [];
			const selectedColumns = values?.action_plans?.selected_columns || [];

			const finalReportOrigins = dataExtractionReport.custom_report_id
				? [dataExtractionReport.custom_report_id]
				: selectedReports;

			const hasActionPlans = finalReportOrigins.length > 0;

			const updatePayload = {
				id: dataExtractionReport.id,
				organization_id: dataExtractionReport.organization_id,
				company_id: dataExtractionReport.company_id,
				data_extraction_reports_action_plan_columns: selectedColumns,
				data_extraction_action_plan_origins: finalReportOrigins,
				has_action_plan_extraction: hasActionPlans,
				current_step_sequence: 3
			};

			await updateDataExtraction(updatePayload);

			onSetShowConfirmationModal(true);
		} catch (error) {
			console.error('Error saving action plans:', error);
		}
	}

	function handleOnCancel(): void {
		onPreviousStep();
	}

	return <StepFooterButtons isLoadingNextButton={isLoading} onSubmit={handleOnSubmit} onCancel={handleOnCancel} />;
}
